import React, { useRef, useState } from 'react'
import Slides from '../slides/Slides'
import { toast, ToastContainer, Zoom } from 'react-toastify';
import showLoading from '../../js/showLoading';
import axios from 'axios';
import Swal from 'sweetalert2';

const Rrhh = ({M}) => {
   const iNombreRef        = useRef(null);
   const iApellidoRef      = useRef(null);
   const iDniRef           = useRef(null);
   const iEmailRef         = useRef(null);
   const iTelefonoRef      = useRef(null);
   const iDomiciolioRef    = useRef(null);
   const iTituloRef        = useRef(null);
   const sSexoRef          = useRef(null);
   const sNacionalidadRef  = useRef(null);
   const sEstudiosRef      = useRef(null);
   const fFileRef          = useRef(null);

   const [rrhh, setRRHH] = useState({
      nombre:        null,
      apellido:      null,
      dni:           null,
      email:         null,
      telefono:      null,
      domicilio:     null,
      sexo:          null,
      nacionalidad:  null,
      estudios:      null,
      titulo:        null,
      file:       null,
   });

   const handleSubmit = (e) => {
      e.preventDefault();
      if (rrhh.nombre === null || rrhh.nombre === "") {
         toast.error("Ingrese el Nombre", { transition: Zoom });
         iNombreRef.current.focus();
         return;
      }
      if (rrhh.apellido === null || rrhh.apellido === "") {
         toast.error("Ingrese el Apellido", { transition: Zoom });
         iApellidoRef.current.focus();
         return;
      }
      if (rrhh.dni === null || rrhh.dni === "") {
         toast.error("Ingrese el D.N.I", { transition: Zoom });
         iDniRef.current.focus();
         return;
      }
      if (rrhh.email === null || rrhh.email === "") {
         toast.error("Ingrese el E-mail", { transition: Zoom });
         iEmailRef.current.focus();
         return;
      }
      if (rrhh.telefono === null || rrhh.telefono === "") {
         toast.error("Ingrese el Teléfono", { transition: Zoom });
         iTelefonoRef.current.focus();
         return;
      }
      if (rrhh.domicilio === null || rrhh.domicilio === "") {
         toast.error("Ingrese el Domicilio", { transition: Zoom });
         iDomiciolioRef.current.focus();
         return;
      }
      if (rrhh.sexo === null || rrhh.sexo === "") {
         toast.error("Ingrese el Sexo", { transition: Zoom });
         sSexoRef.current.focus();
         return;
      }
      if (rrhh.nacionalidad === null || rrhh.nacionalidad === "") {
         toast.error("Ingrese la Nacionalidad", { transition: Zoom });
         sNacionalidadRef.current.focus();
         return;
      }
      if (rrhh.estudios === null || rrhh.estudios === "") {
         toast.error("Ingrese la Estudios", { transition: Zoom });
         sEstudiosRef.current.focus();
         return;
      }
      if (rrhh.titulo === null || rrhh.titulo === "") {
         toast.error("Ingrese la Titulo", { transition: Zoom });
         iTituloRef.current.focus();
         return;
      }
      if (!rrhh.file) {
         toast.error("Debe adjuntar su CV", { transition: Zoom });
         fFileRef.current.focus();
         return;
      }

      showLoading();

      const form = e.target;
      const formData = new FormData(form);
      const formJson = Object.fromEntries(formData.entries());
      formData.append('file',rrhh.file);
      formData.append("fileName", rrhh.file.name);

      axios
      .post(`${process.env.REACT_APP_API_URL}/web/rrhh`,formData)
      .then((payload) => {
         Swal.fire({
            icon: payload.data.icon,
            title: payload.data.title,
            text: payload.data.message,
            showConfirmButton: true,
            confirmButtonText: "Ok",
         }).then((response) => {});
      }).catch((error) => {
         Swal.fire({
            icon: "error",
            title: "Error!",
            text: error.response.data.error,
            showConfirmButton: true,
            confirmButtonText: "Ok",
         });
      });
   }

   return (
      <>
         <Slides M={M} tipoSlides="rrhh"/>
         <div className="container animated fadeIn">
            <div className="section">
               <div className="section center">
                  <h5><strong>Formulario R.R.H.H</strong></h5>
                  <p><strong>Para poder ingresar su currículum vítae complete el siguiente formulario. El mismo quedará en nuestra base de datos de Recursos Humanos.</strong></p>
               </div>
               <form onSubmit={(e) => handleSubmit(e)} encType='multipart/form-data'>
                  <div className="row">
                     <div className="card">
                        <div className="card-content">
                           <div className="row">
                              <div className="input-field col s12 m6">
                                 <input type="text" name="nombre"  id="nombre" ref={iNombreRef}
                                    onChange={(e) => setRRHH({
                                       ...rrhh, 
                                       nombre:e.target.value
                                    })}
                                    className="validate" data-length="15"/>
                                 <label for="nombre">Nombre</label>
                              </div>
                              <div className="input-field col s12 m6">
                                    <input type="text" name="apellido" id="apellido" ref={iApellidoRef} 
                                       onChange={(e) => setRRHH({
                                          ...rrhh, 
                                          apellido:e.target.value
                                       })}
                                       className="validate" data-length="15"/>

                                 <label for="apellido">Apellido</label>
                              </div>
                           </div>
                           <div className="row">
                              <div className="input-field col s12 m6">
                                 <input type="number" name="dni" id="dni" ref={iDniRef}
                                       onChange={(e) => setRRHH({
                                          ...rrhh, 
                                          dni:e.target.value
                                       })}
                                       className="validate" data-length="10"/>
                                 <label for="dni">D.N.I</label>
                              </div>
                              <div className="input-field col s12 m6">
                                 <input type="email" name="email" id="email" ref={iEmailRef}
                                    onChange={(e) => setRRHH({
                                       ...rrhh, 
                                       email:e.target.value
                                    })}
                                 className="validate" data-length="35"/>
                                 <label for="email">E-mail</label>
                              </div>
                           </div>
                           <div className="row">
                              <div className="input-field col s12 m6">
                                 <input type="tel" name="telefono" id="telefono" ref={iTelefonoRef}
                                    onChange={(e) => setRRHH({
                                       ...rrhh, 
                                       telefono:e.target.value
                                    })}
                                    className="validate" data-length="20"/>
                                 <label for="telefono">Teléfono</label>
                              </div>
                              <div className="input-field col s12 m6">
                                 <input type="text" name="domicilio" id="domicilio" ref={iDomiciolioRef}
                                    onChange={(e) => setRRHH({
                                       ...rrhh, 
                                       domicilio:e.target.value
                                    })}
                                    className="validate" data-length="60" />
                                 <label for="domicilio">Domicilio</label>
                              </div>
                           </div>
                           <div className="row">
                              <div className="input-field col s12 m6">
                                 <select name="sexo" id="sexo" ref={sSexoRef}
                                    onChange={(e) => setRRHH({
                                       ...rrhh, 
                                       sexo:e.target.value,
                                    })}
                                    className="browser-default"
                                 >
                                       <option value="" disabled selected>Sexo</option>
                                       <option value="Masculino">Masculino</option>
                                       <option value="Femenino">Femenino</option>
                                 </select>
                              </div>
                              <div className="input-field col s12 m6">
                                 <select name="nacionalidad" id="nacionalidad" ref={sNacionalidadRef}
                                    onChange={(e) => setRRHH({
                                       ...rrhh, 
                                       nacionalidad:e.target.value,
                                    })}
                                    className="browser-default"
                                 >
                                    <option value="" disabled selected>Nacionalidad</option>
                                    <option value="Argentina">Argentina</option>
                                    <option value="Brasil">Brasil</option>
                                 </select>
                              </div>
                           </div>
                           <div className="row">
                              <div className="input-field col s12 m6">
                                 <select name="estudios" id="estudios" ref={sEstudiosRef}
                                    onChange={(e) => setRRHH({
                                       ...rrhh, 
                                       estudios:e.target.value,
                                    })}
                                    className="browser-default"
                                 >
                                       <option value="" disabled selected>Estudios</option>
                                       <option value="Primarios">Primarios</option>
                                       <option value="Secundarios">Secundarios</option>
                                       <option value="Terciarios">Terciarios</option>
                                       <option value="Universitarios">Universitarios</option>
                                       <option value="Maestria">Maestria</option>
                                       <option value="Doctorado">Doctorado</option>
                                 </select>
                              </div>
                              <div className="input-field col s12 m6">
                                 <input type="text" name="titulo" id="titulo" ref={iTituloRef}
                                    onChange={(e) => setRRHH({
                                       ...rrhh, 
                                       titulo:e.target.value
                                    })}
                                    className="validate" data-length="100"/>
                                 <label for="titulo">Titulo</label>
                              </div>
                           </div>
                           <div className="row">
                              <div className="file-field input-field col s12 m6">
                                 <div className="btn waves-effect waves-light light-blue accent-3">
                                       <span>File</span>
                                       <input type="file" name="file" onChange={(e)=>{setRRHH({...rrhh,file:e.target.files[0]})}} ref={fFileRef}/>
                                 </div>
                                 <div className="file-path-wrapper">
                                       <input className="file-path validate" type="text"/>
                                 </div>
                              </div>
                           </div>
                           <div className="row">
                              <div className="col s12 m12 center-align">
                                 <button className="btn waves-effect waves-light light-blue accent-3" type="submit" name="action">Enviar
                                       <i className="material-icons right">send</i>
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </form>
            </div>
         </div>   
         <ToastContainer autoClose={1200}/>
      </>
   )
}

export default Rrhh